import { Button, Form, Input, Select } from "antd";
import BackTitle from "../common/BackTitle";
import FormPage from "../common/FormPage";
import { useEffect } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router-dom";
import IBAN from "iban";
import { filterOption, requiredField } from "../common/common";

export default function () {
    const [form] = Form.useForm();
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance
            .get(`/employee/${id}/clothingSizes`)
            .then(({ data }) => form.setFieldsValue(data));
    });
    const onFinish = (data) => {
        axiosInstance.put(`/employee/${id}/clothingSizes`, data).then(() => {
            navigate(-1);
        });
    };

    return (
        <>
            <FormPage title="Modifica abbigliamento" form={form} onFinish={onFinish}>
                <Form.Item label="Top (maglietta, giacca, felpa)" name="topSize" hasFeedback>
                    <Select
                        options={["XS", "S", "M", "L", "XL", "XXL"].map((x) => ({
                            label: x,
                            value: x,
                        }))}
                        allowClear
                        showSearch
                        filterOption={filterOption}
                    />
                </Form.Item>

                <Form.Item label="Pantaloni" name="bottomSize" hasFeedback>
                    <Select
                        options={["XS", "S", "M", "L", "XL", "XXL"].map((x) => ({
                            label: x,
                            value: x,
                        }))}
                        allowClear
                        showSearch
                        filterOption={filterOption}
                    />
                </Form.Item>

                <Form.Item label="Scarpe" name="shoesSize" hasFeedback>
                    <Select
                        options={[
                            "38",
                            "39",
                            "40",
                            "41",
                            "42",
                            "43",
                            "44",
                            "45",
                            "46",
                            "47",
                            "48",
                            "49",
                            "50",
                        ].map((x) => ({ label: x, value: x }))}
                        allowClear
                        showSearch
                        filterOption={filterOption}
                    />
                </Form.Item>
                <Form.Item label="Guanti" name="glovesSize" hasFeedback>
                    <Select
                        options={["8", "9", "10", "11"].map((x) => ({
                            label: x,
                            value: x,
                        }))}
                        allowClear
                        showSearch
                        filterOption={filterOption}
                    />
                </Form.Item>
                <Form.Item style={{ textAlign: "end" }}>
                    <Button htmlType="submit" type="primary">
                        Salva
                    </Button>
                </Form.Item>
            </FormPage>
        </>
    );
}
